export default {
  "hero.badge": "Ressource indépendante • Mise à jour régulièrement • Axée sur la sécurité",
  "hero.title": "USFans Spreadsheet — découvrez les créateurs, guides et ressources USFans",
  "hero.subtitle": "Explorez un spreadsheet USFans structuré et un centre de ressources conçu pour vous aider à découvrir les informations des créateurs, comparer les ressources, comprendre les frais de livraison et trouver des guides utiles au même endroit.",
  "hero.ctaPrimary": "Explorer USFans Spreadsheet",
  "hero.ctaSecondary": "Parcourir les guides USFans",
  "hero.trust": "Ressource indépendante • Mise à jour régulièrement • Axée sur la sécurité",

  "heroSupport.title": "Vous cherchez un moyen plus simple d'explorer les informations USFans ?",
  "heroSupport.body": "Notre USFans Spreadsheet organise des informations utiles dans une structure facile à parcourir. Explorez les catégories, les guides, les comparaisons, la FAQ et des ressources pratiques depuis un seul centre.",
  "heroSupport.cta": "Ouvrir le USFans Spreadsheet",

  "value.title": "Tout ce qu'il faut savoir sur USFans au même endroit",
  "value.subtitle": "Six ressources clés, organisées pour une recherche plus rapide et plus sûre.",
  "value.spreadsheet.title": "USFans Spreadsheet",
  "value.spreadsheet.body": "Explorez des informations structurées grâce à une ressource de type tableur facile à parcourir.",
  "value.directory.title": "Annuaire des créateurs",
  "value.directory.body": "Parcourez les ressources et catégories liées aux créateurs dans une vue claire et organisée.",
  "value.reviews.title": "Avis sur USFans",
  "value.reviews.body": "Comprenez ce qu'il faut considérer pour évaluer USFans et les services associés.",
  "value.shipping.title": "Livraison et coûts",
  "value.shipping.body": "Explorez les guides sur la livraison, l'entrepôt et les coûts pour mieux planifier.",
  "value.coupons.title": "Coupons et réductions",
  "value.coupons.body": "Trouvez des informations sur les coupons, codes promo et offres.",
  "value.safety.title": "Centre de sécurité",
  "value.safety.body": "Apprenez à repérer les liens suspects et à protéger vos informations.",

  "spreadsheet.title": "Le USFans Spreadsheet",
  "spreadsheet.body": "Le USFans Spreadsheet est la ressource principale de USFansLink.wiki. Il organise des informations utiles sur les créateurs et les ressources dans un format structuré afin que les visiteurs puissent parcourir, comparer et découvrir les informations plus efficacement.",
  "spreadsheet.colCreator": "Créateur / Ressource",
  "spreadsheet.colCategory": "Catégorie",
  "spreadsheet.colType": "Type",
  "spreadsheet.colInfo": "Information",
  "spreadsheet.colUpdated": "Mise à jour",
  "spreadsheet.rowTypeProfile": "Profil",
  "spreadsheet.rowTypeGuide": "Guide",
  "spreadsheet.rowTypeResource": "Ressource",
  "spreadsheet.view": "Voir la ressource",
  "spreadsheet.cta": "Explorer le USFans Spreadsheet complet →",
  "spreadsheet.group.footwear": "Chaussures",
  "spreadsheet.group.apparel": "Vêtements",
  "spreadsheet.group.accessories": "Accessoires",
  "spreadsheet.group.other": "Autres",

  "search.title": "Recherches USFans populaires",
  "search.subtitle": "Accédez aux sujets les plus recherchés.",
  "search.review.title": "Avis sur USFans",
  "search.review.body": "Ce qu'il faut considérer avant de faire confiance à une ressource USFans.",
  "search.shipping.title": "Frais de livraison USFans",
  "search.shipping.body": "Un aperçu pratique de la livraison, des méthodes et des délais.",
  "search.coupon.title": "Coupon USFans",
  "search.coupon.body": "Où chercher des coupons et à quoi s'attendre.",
  "search.discount.title": "Code promo USFans",
  "search.discount.body": "Comment fonctionnent les codes promo et comment les vérifier.",
  "search.warehouse.title": "Entrepôt USFans",
  "search.warehouse.body": "Comprenez le processus d'entrepôt et son rôle.",
  "search.legit.title": "USFans est-il légitime ?",
  "search.legit.body": "Un guide équilibré pour évaluer la légitimité en toute sécurité.",

  "compare.title": "Ressources USFans comparées",
  "compare.colResource": "Ressource",
  "compare.colBestFor": "Idéal pour",
  "compare.colGuides": "Guides",
  "compare.colComparison": "Comparaison",
  "compare.colSafety": "Sécurité",
  "compare.rowSpreadsheet": "USFans Spreadsheet",
  "compare.rowSpreadsheetBest": "Navigation organisée",
  "compare.rowDirectory": "Annuaire des créateurs",
  "compare.rowDirectoryBest": "Découverte",
  "compare.rowShipping": "Guide de livraison",
  "compare.rowShippingBest": "Recherche sur la livraison",
  "compare.rowReview": "Guide d'avis",
  "compare.rowReviewBest": "Évaluation",

  "how.title": "Comment fonctionne le centre de ressources USFans",
  "how.subtitle": "Un processus simple en quatre étapes pour rechercher en toute confiance.",
  "how.step1.title": "Explorez",
  "how.step1.body": "Trouvez le USFans Spreadsheet ou un sujet précis.",
  "how.step2.title": "Comparez",
  "how.step2.body": "Utilisez les guides et tableaux pour comprendre les différences.",
  "how.step3.title": "Vérifiez",
  "how.step3.body": "Consultez les informations de sécurité avant de visiter des sites externes.",
  "how.step4.title": "Continuez",
  "how.step4.body": "Visitez le site principal lorsque des ressources supplémentaires sont pertinentes.",
  "how.cta": "Explorer USFans Spreadsheet",

  "trust.title": "Conçu pour une meilleure recherche USFans",
  "trust.subtitle": "Des standards clairs, des informations transparentes et des conseils honnêtes.",
  "trust.item1": "Plateforme de ressources indépendante",
  "trust.item2": "Contenu éditorial",
  "trust.item3": "Dates de mise à jour claires",
  "trust.item4": "Conseils de sécurité",
  "trust.item5": "Avertissement transparent",
  "trust.item6": "Aucun faux avis",
  "trust.item7": "Aucune statistique inventée",
  "trust.about": "À propos",
  "trust.editorial": "Politique éditoriale",
  "trust.update": "Politique de mise à jour",
  "trust.safetyLink": "Centre de sécurité",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides aux questions les plus courantes sur le USFans Spreadsheet.",
  "faq.q1": "Qu'est-ce qu'un spreadsheet USFans ?",
  "faq.a1": "Un spreadsheet USFans est une ressource structurée qui organise les informations des créateurs, des catégories et des références dans un format unique facile à parcourir.",
  "faq.q2": "Comment fonctionne le spreadsheet USFans ?",
  "faq.a2": "Il regroupe les informations liées en lignes et en catégories afin que vous puissiez parcourir, comparer et accéder aux ressources pertinentes sans ouvrir de nombreuses pages.",
  "faq.q3": "Quelles informations puis-je trouver ?",
  "faq.a3": "Vous pouvez trouver des références de créateurs, des liens de catégories, des guides et des ressources pratiques liés à l'exploration du contenu USFans.",
  "faq.q4": "USFans est-il légitime ?",
  "faq.a4": "Nous proposons des conseils pour évaluer la légitimité plutôt qu'un verdict unique. Vérifiez toujours les sources et évitez les liens suspects.",
  "faq.q5": "Combien coûte la livraison USFans ?",
  "faq.a5": "Les frais de livraison varient selon la région, la méthode et la commande. Consultez les derniers détails sur le site principal avant d'acheter.",
  "faq.q6": "USFans propose-t-il des coupons ?",
  "faq.a6": "Des coupons et promotions peuvent apparaître de temps à autre. Nous recommandons de vérifier toute offre active directement sur le site principal.",
  "faq.q7": "Qu'est-ce qu'un code promo USFans ?",
  "faq.a7": "Un code promo est un court texte saisi au moment du paiement pour appliquer une promotion. Confirmez toujours qu'un code est valide avant de l'utiliser.",
  "faq.q8": "Comment fonctionne l'entrepôt USFans ?",
  "faq.a8": "L'entrepôt gère le stockage et l'expédition des commandes. Les délais peuvent dépendre de la localisation et de la disponibilité du stock.",
  "faq.q9": "Comment évaluer les avis sur USFans ?",
  "faq.a9": "Recherchez des retours cohérents et détaillés provenant de plusieurs sources plutôt que de vous fier à un seul avis ou à une seule note.",
  "faq.q10": "USFansLink.wiki est-il officiellement affilié à USFans ?",
  "faq.a10": "Non. USFansLink.wiki est une ressource d'information indépendante et n'est pas affiliée ni approuvée par USFans.",

  "finalCta.title": "Commencez à explorer le USFans Spreadsheet",
  "finalCta.body": "Parcourez les ressources, guides, comparaisons et informations de sécurité USFans depuis un seul centre.",
  "finalCta.primary": "Explorer USFans Spreadsheet",
  "finalCta.secondary": "Visiter le site principal",

  "pillar.title": "Guides et ressources USFans",
  "pillar.subtitle": "Des guides originaux et détaillés sur les avis, la livraison, les coupons, la sécurité et plus encore.",
  "pillar.readMore": "Lire le guide",
};